<template>

  <v-container fluid style="margin-top:80px;" class="page page-forgot-password">

    <v-container class="page-content pb-8">
      <!-- Title -->
      <v-row>
        <v-col>
          <div class="page-title">
            Send Password Reset
          </div>
        </v-col>
      </v-row>

      <!-- Info -->
      <v-row class="mt-2">
        <v-col>
          <div class="info-text">
            Instructions will be sent to your email allowing to reset your password.
          </div>
        </v-col>
      </v-row>

      <!-- Email Entry -->
      <v-row>
        <v-col cols="12" xs="12" sm="8" md="6" lg="5" class="d-flex align-center justify-center">
          <div class="mr-5">Account email:</div>
          <v-text-field
              outlined
              hide-details
              :disabled="passwordResetSentMessage !== null"
              v-model="email" />
        </v-col>
      </v-row>

      <!-- Action -->
      <v-row class="mt-5">
        <v-col cols="12" class="d-flex align-center justify-start">
          <v-btn
              large
              color="primary"
              :disabled="!email || passwordResetSentMessage !== null || isProcessing"
              @click="sendPasswordReset">
            <span v-if="isProcessing">Requesting...</span>
            <span v-else>Reset Password</span>
          </v-btn>
        </v-col>
      </v-row>

      <!-- Action Error -->
      <v-row class="mt-5" v-if="processingError">
        <v-col cols="12" class="d-flex align-center justify-start">
          <div class="pl-2">
            <v-icon color="red" class="pr-2 pb-1">mdi-alert-circle-outline</v-icon>
            <span style="font-size:1.08rem;">{{ processingError }}</span>
            <v-btn
                class="ml-10"
                @click="processingError = null">
              Ok
            </v-btn>
          </div>
        </v-col>
      </v-row>

      <!-- Action Success -->
      <v-row class="mt-5" v-if="passwordResetSentMessage">
        <v-col cols="12" class="d-flex align-center justify-start">
          <div class="pl-2">
            <v-icon color="green" class="mr-1 pb-1">mdi-check</v-icon>
            <span style="color:#4caf4f;font-size:1.08rem;">{{ passwordResetSentMessage }}</span>
            <v-btn
                outlined
                color="amber darken-2"
                class="ml-10"
                @click="$root.goTo('login')">
              Go to Login
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>

  </v-container>

</template>

<script>
import { Auth } from 'aws-amplify'

export default {
  name: 'ForgotPasswordPage',

  data () {
    return {
      isProcessing: false,
      processingError: null,
      email: null,
      passwordResetSentMessage: null
    }
  },

  computed: {
    appName () {
      return this.$store.getters['app/platform']
    }
  },

  methods: {
    async sendPasswordReset () {
      if (!this.email) return false
      this.isProcessing = true

      try {
        await Auth.forgotPassword(this.email)
        this.passwordResetSentMessage = 'A password reset request has been made. Please check your email.'
      } catch (err) {
        this.processingError = err.message || err.text || err
      } finally {
        this.isProcessing = false
      }
    }
  }
}
</script>

<style scoped>
  .info-text {
    font-size: 1.08rem;
    color: #9c9c9c;
    font-weight: 400;
  }

  .error-text {
    font-size: 1.08rem;
    color: #cc0000;
    font-weight: 400;
  }
</style>
